import React, { useContext } from "react";
import "./home-style.css";
import LanguageContext from "../../context/LanguageContext";

const jsonDataEn = require("./data/home-data-en.json");
const jsonDataFr = require("./data/home-data-fr.json");

const Steps = () => {
  const { language } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data.steps : jsonDataFr.data.steps;
  return (
    <section className="steps">
      <div className="steps__inner">
        <h2 className="steps__title">
          {data.title1} <span className="accent">FlxDeck</span> {data.title2}
        </h2>
        <p className="steps__desc">{data.description} </p>

        <div className="steps__wrap">
          {/* Connecting line with markers */}
          <div className="steps__track" aria-hidden="true">
            <span className="dot" />
            <span className="dot" />
            <span className="dot" />
          </div>

          <ul className="steps__grid">
            <li className="step">
              <img src="/assets/home/No1.webp" alt="Step 1" className="step__badge" />
              <h3 className="step__title">{data.step1}</h3>
              <p className="step__text">{data.description1}</p>
            </li>

            <li className="step">
              <img src="/assets/home/No2.webp" alt="Step 2" className="step__badge" />
              <h3 className="step__title">{data.step2}</h3>
              <p className="step__text">{data.description2}</p>
            </li>

            <li className="step">
              <img src="/assets/home/No3.webp" alt="Step 3" className="step__badge" />
              <h3 className="step__title">{data.step3}</h3>
              <p className="step__text">{data.description3}</p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Steps;
